import React,{useState} from 'react'
import { LoginForm } from '../../components'
import { useNavigate,Navigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {handleApi} from "../../utils/authentication"
import { useDispatch,useSelector } from 'react-redux';
import {SIGNIN_USER}  from "../../redux/features/user/userSlice"
import { toast } from 'react-toastify';



const SuperAdminLogin = () => {

  const [isLoading,setIsLoading]=useState(false)
  const [error,setError]=useState()
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const user=useSelector((state)=>state?.user)
  
    const handleSuperAdminLogin= async ()=>{
    try{
      setIsLoading(true)
        let method ="POST"
        let headers={
          "Content-Type":"application/json"
        }
        let data=JSON.stringify(formik?.values)
        let result=await handleApi('admin_login',method,headers,data)
     
      
        if(result?.success)
          {
            dispatch(SIGNIN_USER({...result?.data?.user_info,isLoggedIn:true,is_super_admin:true}))

            navigate('/super_admin')
    
          }
          else{
            setError(result?.error?.error_message)
            toast.error(result?.error?.error_message?result?.error?.error_message:"Something Went wrong! Please try again later ", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
          setIsLoading(false)
      }
       catch(e)
       {
        console.log(e)
        setIsLoading(false)
        setError(e?.message)
        toast.error(e.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
       }
    
    

    }

    //formik validtion 
    const validationSchema = Yup.object({
      email:Yup.string().email('Invalid email address').required('Email is Required'),
      password:Yup.string().required('Password is Required'),
    });
  const formik = useFormik({
      initialValues: {
        email:'',
        password:''
      },
      validationSchema:validationSchema,
       onSubmit: (values) => {
    
         handleSuperAdminLogin()
      },
    });
    
    if(user?.isLoggedIn && user?.is_super_admin)
      {
        return <Navigate to="/super_admin/" />
        
  
      }
  return (
   
        <LoginForm formik={formik}   isLoading={isLoading} error={error}  />
    
  )
}

export default SuperAdminLogin